import { Breadcrumb, Card, Space, Spin, Typography } from "antd";
import classNames from "classnames";
import LinkWithParams from "components/elements/LinkWithParams";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appRoutes } from "config/appRoutes.config";
import styles from "./View.module.less";

interface Props {
  children: React.ReactNode | null;
  title?: string | React.ReactNode;
  withGreyBackground?: boolean;
  withBreadcrumbs?: boolean;
  isLoading?: boolean;
}

const { Title } = Typography;

function View({
  children,
  title,
  withGreyBackground,
  withBreadcrumbs = true,
  isLoading = false,
}: Props): JSX.Element {
  const location = useLocation();

  const { t } = useTranslation();

  const breadcrumbNameMap: { [key: string]: string } = {
    "/suche": t(appRoutes.find((x) => x.path === "/suche")?.name as string),
    "/upload": t(appRoutes.find((x) => x.path === "/upload")?.name as string),
    "/tickets": t(appRoutes.find((x) => x.path === "/tickets")?.name as string),
    "/monitoring": t(
      appRoutes.find((x) => x.path === "/monitoring")?.name as string
    ),
    "/reporting": t(
      appRoutes.find((x) => x.path === "/reporting")?.name as string
    ),
    "/versand": t(appRoutes.find((x) => x.path === "/versand")?.name as string),
    "/user": t(appRoutes.find((x) => x.path === "/user")?.name as string),
    "/datum-management": t(
      appRoutes.find((x) => x.path === "/datum-management")?.name as string
    ),
    "/reserven-aktivieren": t(
      appRoutes.find((x) => x.path === "/reserven-aktivieren")?.name as string
    ),
    "/incentiveManagement": t(
      appRoutes.find((x) => x.path === "/incentiveManagement")?.name as string
    ),
  };

  const pathSnippets = location.pathname.split("/").filter((i) => i);

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    return (
      <Breadcrumb.Item key={url}>
        <LinkWithParams to={url}>{breadcrumbNameMap[url]}</LinkWithParams>
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [
    <Breadcrumb.Item key="home">
      <LinkWithParams to="/">Home</LinkWithParams>
    </Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <Card
      className={classNames({
        [styles.view]: true,
        [styles.grey_view]: withGreyBackground,
      })}
      title={
        title && (
          <Space direction="vertical">
            <Title level={1}>{title}</Title>
            {withBreadcrumbs && <Breadcrumb>{breadcrumbItems}</Breadcrumb>}
          </Space>
        )
      }
      bordered
    >
      {isLoading ? (
        <div className={styles.spin_wrapper}>
          <Spin />
        </div>
      ) : (
        children
      )}
    </Card>
  );
}

export default View;
